/** AuthContainerV2 public barrel. */
export { AuthContainerV2 } from './AuthContainerV2';
export type {
  AuthContainerV2Props,
  AuthSurface,
  AuthMethod,
  AuthAction,
  AuthSuccessEventDetail,
  PaywallUnlockedEventDetail,
} from './types';
export { AUTH_SUCCESS_EVENT, PAYWALL_UNLOCKED_EVENT } from './types';

export { resolveReturnUrl } from './utils/resolveReturnUrl';
export type { ResolveReturnUrlInput, ResolveReturnUrlResult } from './utils/resolveReturnUrl';
export { emitAuthSuccess } from './utils/emitAuthSuccess';
export { emitPaywallUnlocked } from './utils/emitPaywallUnlocked';
export { loginUrlFor } from './utils/loginUrlFor';
export type { LoginUrlOptions } from './utils/loginUrlFor';

export { useAuth } from './hooks/useAuth';
export type { UseAuthReturn, UseAuthState } from './hooks/useAuth';
export { useAuthTracking } from './hooks/useAuthTracking';
export type { UseAuthTrackingInput, UseAuthTrackingReturn, TrackAuthSuccessInput } from './hooks/useAuthTracking';

// Individual surface exports — for consumers that want to compose without the dispatcher.
export { PageSurface } from './surfaces/PageSurface';
export { PaywallSurface } from './surfaces/PaywallSurface';
export { RegwallSurface } from './surfaces/RegwallSurface';
export { SmsVerifySurface } from './surfaces/SmsVerifySurface';
export type { SmsVerifySurfaceProps } from './surfaces/SmsVerifySurface';
